import { simpleSet } from '@r/reducers/utils';

const setCabinetSetMaterialMode = simpleSet as
  redux.reducers.flags.cabinetSetMaterialMode;
export const cabinetSetMaterialMode = setCabinetSetMaterialMode(
  'SET_CABINET_SET_MATERIAL_MODE',
  'singleCabinet'
);
